// Номер ковра привязан к конкретному ноутбуку (браузеру), а не к пользователю или поединку —
// выбирается один раз перед турниром и хранится локально.
const MAT_NUMBER_KEY = 'judo_mat_number';
const MAT_CONTROLLER_KEY = 'judo_mat_controller_id';

export const getMatNumber = (): string | null => {
  try {
    return localStorage.getItem(MAT_NUMBER_KEY);
  } catch {
    return null;
  }
};

export const setMatNumber = (value: string): void => {
  try {
    localStorage.setItem(MAT_NUMBER_KEY, value);
  } catch {
    // localStorage недоступен (приватный режим и т.п.) — просто не запоминаем
  }
};

export const clearMatNumber = (): void => {
  try {
    localStorage.removeItem(MAT_NUMBER_KEY);
  } catch {
    // ignore
  }
};

/** Стабильный id этого браузера, чтобы после перезагрузки страницы ковёр можно было занять снова. */
export const getMatControllerId = (): string => {
  try {
    let id = localStorage.getItem(MAT_CONTROLLER_KEY);
    if (!id) {
      id = (typeof crypto !== 'undefined' && crypto.randomUUID)
        ? crypto.randomUUID()
        : `mat-${Date.now()}-${Math.random().toString(16).slice(2)}`;
      localStorage.setItem(MAT_CONTROLLER_KEY, id);
    }
    return id;
  } catch {
    return `session-${Date.now()}`;
  }
};
